import type { Location } from './types.js';

export const sensojiLocations: Location[] = [
  {
    "id": "pin-1775805162965",
    "number": 1,
    "name": "Skytree view",
    "nameJa": "",
    "description": "",
    "x": 79.9,
    "y": 78.4,
    "mapsUrl": "https://maps.app.goo.gl/wfevQLMViydbQ7oc7",
    "tip": "Một địa điểm chụp nơi bạn có thể thấy cả khu phố mang nét cổ của Nhật Bản và tháp Skytree phía sau. Dù là ban ngày hay khi phố lên đèn, Skytree vẫn hiện lên như một điểm nhấn đặc biệt, tạo nên khung hình vừa đẹp vừa có chiều sâu.",
    "allowNight": true,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924038/kra-asakusa/1/drive_tgwJgdN__1775924038.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924376/kra-asakusa/1/drive_U3mvcBHx_1775924376.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922677/kra-asakusa/1/drive_D1tXR0zT_1775922677.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968523/kra-asakusa/1/drive_EU6T2RO3_1775968521.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922450/kra-asakusa/1/drive_kqHcAlKd_1775922450.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968524/kra-asakusa/1/drive_nirHntWn_1775968524.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922971/kra-asakusa/1/drive_sOmT_0Zr_1775922970.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922513/kra-asakusa/1/drive_SQ7_HPw1_1775922512.jpg"
    ],
    "hiddenPhotos": [],
    "tipTranslations": {
      "en": "A photo spot where you can see both the traditional streets of Japan and the Skytree in the background. Whether during the day or when the streets are lit up, the Skytree stands out as a special highlight, creating a beautiful and deep frame.",
      "zh": "一个拍照地点，您可以看到日本传统街道和背景中的东京晴空塔。无论是白天还是街道亮起灯光时，晴空塔都作为一个特别的亮点，创造出既美丽又有深度的画面。",
      "ja": "日本の伝統的な街並みと背景にスカイツリーが見える撮影スポットです。昼間でも、街が灯りをともしている時でも、スカイツリーは特別なハイライトとして際立ち、美しく深みのあるフレームを作り出します。",
      "th": "สถานที่ถ่ายภาพที่คุณสามารถเห็นทั้งถนนเก่าของญี่ปุ่นและหอคอยสกายทรีอยู่เบื้องหลัง ไม่ว่าจะเป็นเวลากลางวันหรือตอนที่ถนนเปิดไฟ สกายทรีจะโดดเด่นเป็นจุดเด่นพิเศษ สร้างกรอบภาพที่สวยงามและมีมิติ",
      "id": "Tempat foto di mana Anda dapat melihat jalanan tradisional Jepang dan Skytree di latar belakang. Baik siang maupun saat jalanan diterangi, Skytree tetap menjadi sorotan khusus, menciptakan bingkai yang indah dan dalam.",
      "es": "Un lugar para fotos donde puedes ver tanto las calles tradicionales de Japón como la Skytree al fondo. Ya sea de día o cuando las calles están iluminadas, la Skytree se destaca como un punto focal especial, creando un marco que es tanto hermoso como profundo."
    },
    "photos": []
  },
  {
    "id": "pin-1775917619468",
    "number": 2,
    "name": "Benten-dō",
    "nameJa": "弁天堂",
    "description": "",
    "x": 74.8,
    "y": 64.7,
    "mapsUrl": "https://maps.app.goo.gl/wv6bXnyh5xrd19D28",
    "tip": "Địa điểm chụp rất đẹp vào mùa lá vàng, nơi bạn có thể cảm nhận như đang đứng giữa một không gian phủ đầy sắc thu. Vừa có nền lá vàng, vừa có kiến trúc chùa phía sau, tạo nên khung hình đậm chất Nhật Bản. Chỉ trong một khu vực nhỏ nhưng có thể chụp được nhiều góc đa dạng. Ngay cả vào ngày thường, nơi đây vẫn có thể tạo ra những bức ảnh với background chùa rất đẹp.",
    "allowNight": false,
    "allowSakura": false,
    "allowMomiji": true,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775967324/kra-asakusa/2/drive_ziee99XE_1775967323.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775967328/kra-asakusa/2/drive_i_ZsH6el_1775967327.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968613/kra-asakusa/2/drive_i2QKm8Jm_1775968612.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922607/kra-asakusa/2/drive_LmWnRzqq_1775922607.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924182/kra-asakusa/2/drive_d9iX42o5_1775924181.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923935/kra-asakusa/2/drive_gucd6A7d_1775923934.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924835/kra-asakusa/2/drive_hx8QMwfZ_1775924835.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921174/kra-asakusa/2/drive_iMrT-04H_1775921172.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922110/kra-asakusa/2/drive_iUaQlcQ8_1775922108.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775920199/kra-asakusa/2/drive_v3NCWDNL_1775920197.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924837/kra-asakusa/2/drive_ZF45npx1_1775924837.jpg"
    ],
    "hiddenPhotos": [],
    "tipTranslations": {
      "en": "The location is stunning during the autumn leaves season, where you can feel like you're in a space filled with fall colors. With a backdrop of golden leaves and temple architecture, it creates a frame rich in Japanese essence. In a small area, you can capture many diverse angles. Even on regular days, this place can produce beautiful photos with a temple background.",
      "zh": "这个地点在秋叶季节非常美丽，您可以感受到仿佛置身于一个充满秋色的空间。金色的叶子和寺庙建筑的背景，营造出浓厚的日本风情。在一个小区域内，您可以拍摄到多种不同的角度。即使在普通日子，这里也能拍出美丽的寺庙背景照片。",
      "ja": "この場所は秋の葉が美しい季節に素晴らしいです。秋の色に満ちた空間にいるような感覚を味わえます。黄金色の葉と寺院の建築が背景となり、日本のエッセンスが豊かなフレームを作り出します。小さなエリアの中で多様なアングルを捉えることができます。平日でも、ここでは美しい寺院の背景の写真を撮ることができます。",
      "th": "สถานที่นี้สวยงามมากในฤดูใบไม้ร่วงที่มีใบไม้เปลี่ยนสี คุณจะรู้สึกเหมือนยืนอยู่ในพื้นที่ที่เต็มไปด้วยสีสันของฤดูใบไม้ร่วง ด้วยพื้นหลังของใบไม้สีทองและสถาปัตยกรรมวัด สร้างกรอบภาพที่มีเอกลักษณ์ของญี่ปุ่น ในพื้นที่เล็กๆ นี้คุณสามารถถ่ายภาพมุมต่างๆ ได้มากมาย แม้ในวันธรรมดาที่นี่ก็ยังสามารถสร้างภาพถ่ายที่มีพื้นหลังวัดที่สวยงามได้",
      "id": "Lokasi ini sangat indah saat musim daun gugur, di mana Anda dapat merasakan seperti berdiri di ruang yang dipenuhi warna musim gugur. Dengan latar belakang daun emas dan arsitektur kuil, menciptakan bingkai yang kaya akan esensi Jepang. Di area kecil ini, Anda dapat mengambil banyak sudut yang beragam. Bahkan pada hari biasa, tempat ini masih dapat menghasilkan foto-foto indah dengan latar belakang kuil.",
      "es": "El lugar es impresionante durante la temporada de hojas de otoño, donde puedes sentirte como si estuvieras en un espacio lleno de colores otoñales. Con un fondo de hojas doradas y arquitectura de templos, crea un marco rico en esencia japonesa. En un área pequeña, puedes capturar muchos ángulos diversos. Incluso en días normales, este lugar puede producir fotos hermosas con un fondo de templo."
    },
    "photos": []
  },
  {
    "id": "pin-1775918500747",
    "number": 3,
    "name": "Hozomon Gate",
    "nameJa": "宝蔵門",
    "description": "",
    "x": 58.6,
    "y": 60.4,
    "mapsUrl": "https://maps.app.goo.gl/U3KVEAp4RH4jytfn7",
    "tip": "Một trong những điểm chụp mang tính biểu tượng tại Sensoji. Tuy nhiên, khu vực này thường rất đông, nên thời điểm lý tưởng để chụp là trước 9 giờ sáng hoặc sau 6 giờ chiều để có khung hình thoáng và đẹp hơn.",
    "allowNight": true,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": true,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968625/kra-asakusa/3/drive_5BDYLAX1_1775968625.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924532/kra-asakusa/3/drive_KUv3xTRo_1775924532.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776214852/kra-asakusa/3/drive_TWbBah3t_1776214852.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776214854/kra-asakusa/3/drive_xNxC2rIf_1776214854.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923916/kra-asakusa/3/drive_aQa8eKw2_1775923915.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923978/kra-asakusa/3/drive_b8YavSti_1775923977.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924031/kra-asakusa/3/drive_bty3Nb_2_1775924031.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775918564/kra-asakusa/3/drive_cDeNrCkt_1775918562.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923981/kra-asakusa/3/drive_DwXX9FzR_1775923979.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924852/kra-asakusa/3/drive_F-28kETe_1775924852.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924855/kra-asakusa/3/drive_n0XcVzV6_1775924855.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924536/kra-asakusa/3/drive_xDTa5kkI_1775924535.jpg"
    ],
    "hiddenPhotos": [],
    "tipTranslations": {
      "en": "One of the iconic photo spots at Sensoji. However, this area is often very crowded, so the ideal times for photos are before 9 AM or after 6 PM for a clearer and more beautiful shot.",
      "zh": "这是浅草寺的一个标志性拍照地点。然而，这个区域通常非常拥挤，因此理想的拍照时间是在上午9点之前或下午6点之后，以获得更清晰和更美丽的照片。",
      "ja": "浅草寺の象徴的な撮影スポットの一つです。しかし、このエリアは非常に混雑することが多いので、理想的な撮影時間は午前9時前または午後6時以降です。そうすれば、よりクリアで美しい写真が撮れます。",
      "th": "หนึ่งในจุดถ่ายภาพที่มีชื่อเสียงที่เซนโซจิ อย่างไรก็ตามพื้นที่นี้มักจะมีผู้คนหนาแน่น ดังนั้นเวลาที่เหมาะสมในการถ่ายภาพคือก่อน 9 โมงเช้าหรือหลัง 6 โมงเย็นเพื่อให้ได้ภาพที่ชัดเจนและสวยงามมากขึ้น",
      "id": "Salah satu tempat foto ikonik di Sensoji. Namun, area ini seringkali sangat ramai, jadi waktu yang ideal untuk foto adalah sebelum jam 9 pagi atau setelah jam 6 sore untuk mendapatkan gambar yang lebih jelas dan indah.",
      "es": "Uno de los lugares de fotos icónicos en Sensoji. Sin embargo, esta área suele estar muy concurrida, por lo que los momentos ideales para tomar fotos son antes de las 9 AM o después de las 6 PM para obtener una imagen más clara y hermosa."
    },
    "photos": []
  },
  {
    "id": "pin-1775919695696",
    "number": 4,
    "name": "Five-Storied Pagoda",
    "nameJa": "五重塔",
    "description": "",
    "x": 51.8,
    "y": 49,
    "mapsUrl": "https://maps.app.goo.gl/9uz8JFbPop9ZjCnA8",
    "tip": "Đây là một trong những góc chụp nổi bật tại Sensoji, với tháp 5 tầng phía sau làm điểm nhấn. Khi chụp vào buổi tối, khung cảnh mang lại cảm giác huyền bí nhưng vẫn rất lộng lẫy.\nBan ngày khu vực này thường khá đông, nên sẽ khó có được khung hình sạch. Thời điểm lý tưởng là buổi sáng sớm để dễ chụp hơn và hạn chế việc xử lý hậu kỳ.",
    "allowNight": true,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": true,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921547/kra-asakusa/4/drive_Ganou65c_1775921546.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775920013/kra-asakusa/4/drive_o5eQXiTv_1775920011.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924846/kra-asakusa/4/drive_N-ZEyxpC_1775924846.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921401/kra-asakusa/4/drive_ZpXM4UB1_1775921400.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969896/kra-asakusa/4/drive_6sCfowUR_1775969895.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969461/kra-asakusa/4/drive_DyQnQteE_1775969460.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969309/kra-asakusa/4/drive_grfjmO0f_1775969308.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921405/kra-asakusa/4/drive_jLq-cVMR_1775921404.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969893/kra-asakusa/4/drive_UmrH-aU7_1775969893.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "One of the standout photo spots at Sensoji, with the five-story pagoda behind you as the focal point. At night the scene feels mysterious yet still magnificent.\nDuring the day this area is usually crowded, so a clean shot is hard to get. Early morning is the ideal time: easier to shoot and less editing afterwards."
    }
  },
  {
    "id": "pin-1775919896586",
    "number": 5,
    "name": "Main Hall (1)",
    "nameJa": "",
    "description": "",
    "x": 66.3,
    "y": 28.6,
    "mapsUrl": "https://maps.app.goo.gl/Ag5TWttmr3aJURPy7",
    "tip": "Một trong những góc chụp nổi bật tại Sensoji, nơi toàn bộ khung cảnh mang đậm nét Nhật Bản với đèn lồng đỏ lớn, ban công đỏ và tháp 5 tầng phía sau.\nKhi chụp từ xa, các lớp kiến trúc xếp chồng tạo nên hiệu ứng chiều sâu rất ấn tượng, giúp khung hình trở nên nổi bật hơn.",
    "allowNight": true,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": true,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775920156/kra-asakusa/5/drive_4PJagU51_1775920155.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924724/kra-asakusa/5/drive_c26LT2oy_1775924724.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922643/kra-asakusa/5/drive_cY7wbmwd_1775922643.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923837/kra-asakusa/5/drive_FkokcH4b_1775923837.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924783/kra-asakusa/5/drive_SFE3YH-H_1775924782.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924722/kra-asakusa/5/drive_ZRK_EEIv_1775924722.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921062/kra-asakusa/5/drive_H5V7oq2B_1775921060.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968690/kra-asakusa/5/drive_I4vsRNdn_1775968688.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923835/kra-asakusa/5/drive_R7cmBfdB_1775923833.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "One of the standout photo spots at Sensoji, where the whole scene feels deeply Japanese: the giant red lantern, the red balconies and the five-story pagoda behind.\nShot from a distance, the layers of architecture stack up into an impressive sense of depth that makes the photo really stand out."
    }
  },
  {
    "id": "pin-1775919963834",
    "number": 6,
    "name": "Main Hall Front",
    "nameJa": "",
    "description": "",
    "x": 70.2,
    "y": 32.2,
    "mapsUrl": "https://maps.app.goo.gl/wRmcWLF7nLucTcus7",
    "tip": "Một địa điểm rất phù hợp để chụp ảnh vào buổi tối, khi toàn bộ khu vực được thắp sáng, tạo nên khung cảnh nổi bật và ấn tượng.\nPhía sau là chùa Sensoji với quy mô lớn, giúp bức ảnh có chiều sâu và cảm giác hoành tráng.\nVào buổi sáng, khu vực này thường đông hơn nên sẽ khó chụp hơn một chút.",
    "allowNight": true,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921520/kra-asakusa/6/drive_t-vj55Qe_1775921519.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921135/kra-asakusa/6/drive_KRlowRfx_1775921134.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921138/kra-asakusa/6/drive_xY4PjAc6_1775921137.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923444/kra-asakusa/6/drive_cDccTkn9_1775923442.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968564/kra-asakusa/6/drive_ftGV1ecX_1775968563.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923441/kra-asakusa/6/drive_PB5trX_K_1775923439.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "A great spot for evening photos, when the whole area is lit up and the scene looks striking.\nThe huge Sensoji main hall behind you gives the photo depth and a sense of grandeur.\nIn the morning it is usually more crowded, so shooting here is a little harder."
    }
  },
  {
    "id": "pin-1775920482574",
    "number": 7,
    "name": "Main Hall (Left) ",
    "nameJa": "",
    "description": "",
    "x": 49.9,
    "y": 20.8,
    "mapsUrl": "https://maps.app.goo.gl/Y85J8bj2Kjf2xTPn7",
    "tip": "Một trong những góc chụp biểu tượng tại Asakusa, với tháp 5 tầng làm background nổi bật phía sau, tạo nên khung cảnh đậm chất truyền thống Nhật Bản. Đây là địa điểm gần như không thể bỏ qua khi ghé thăm chùa Sensoji.",
    "allowNight": true,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": true,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969172/kra-asakusa/7/drive_mRxDcEfC_1775969169.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969673/kra-asakusa/7/drive_HIu8SQ7s_1775969673.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924900/kra-asakusa/7/drive_rVN7NP9J_1775924900.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923378/kra-asakusa/7/drive_s2M-cTzl_1775923377.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923895/kra-asakusa/7/drive_O-PWwC1N_1775923893.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968469/kra-asakusa/7/drive_S9tr1Ix-_1775968467.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923453/kra-asakusa/7/drive_Bawx7JpJ_1775923452.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921045/kra-asakusa/7/drive_PCTOQk3a_1775921045.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922554/kra-asakusa/7/drive_g3JJhzj2_1775922554.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924295/kra-asakusa/7/drive_KOGOgFDi_1775924294.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968472/kra-asakusa/7/drive_mRYi1Ow__1775968470.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923176/kra-asakusa/7/drive_NivCx2yV_1775923175.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924161/kra-asakusa/7/drive_TwZR13fx_1775924159.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924152/kra-asakusa/7/drive_UnroL4fe_1775924151.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921034/kra-asakusa/7/drive_yynYT-gB_1775921032.jpg"
    ],
    "hiddenPhotos": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924155/kra-asakusa/7/drive_5vfUBJu3_1775924154.jpg"
    ],
    "tipTranslations": {
      "en": "One of the iconic photo spots in Asakusa, with the five-story pagoda as a prominent background, creating a scene rich in traditional Japanese culture. This is a must-visit location when visiting Sensoji Temple.",
      "zh": "这是浅草的一个标志性拍照地点，五层塔作为突出的背景，营造出浓厚的日本传统文化场景。参观浅草寺时，这是一个不可错过的地方。",
      "ja": "浅草の象徴的な撮影スポットの一つで、五重塔が目立つ背景となり、日本の伝統文化が色濃く表現されています。浅草寺を訪れる際には、ぜひ立ち寄りたい場所です。",
      "th": "หนึ่งในมุมถ่ายภาพที่มีชื่อเสียงในอาซากุสะ โดยมีเจดีย์ห้าชั้นเป็นพื้นหลังที่โดดเด่น สร้างบรรยากาศที่เต็มไปด้วยวัฒนธรรมญี่ปุ่นแบบดั้งเดิม นี่คือสถานที่ที่ไม่ควรพลาดเมื่อเยี่ยมชมวัดเซนโซจิ",
      "id": "Salah satu spot foto ikonik di Asakusa, dengan pagoda lima lantai sebagai latar belakang yang mencolok, menciptakan suasana yang kaya akan budaya tradisional Jepang. Ini adalah lokasi yang wajib dikunjungi saat mengunjungi Kuil Sensoji.",
      "es": "Uno de los lugares de fotos icónicos en Asakusa, con la pagoda de cinco pisos como fondo destacado, creando una escena rica en cultura japonesa tradicional. Este es un lugar que no se puede perder al visitar el Templo Sensoji."
    },
    "photos": []
  },
  {
    "id": "pin-1775920680260",
    "number": 8,
    "name": "Awashimado Hall",
    "nameJa": "淡島堂",
    "description": "",
    "x": 20.9,
    "y": 24.1,
    "mapsUrl": "https://maps.app.goo.gl/sXPLkqSb4W2o2YZG6",
    "tip": "Một trong những spot chụp đa dạng nhất tại Asakusa, với nhiều góc có thể khai thác trong cùng một khu vực.\nGóc đặc trưng nhất là với tháp 5 tầng phía sau, mang lại cảm giác rất Nhật Bản. Vào mùa sakura, khung cảnh càng trở nên đặc biệt hơn với sự xuất hiện của hoa anh đào. Đây là địa điểm mà hầu như mọi buổi chụp tại Sensoji đều sẽ ghé qua.",
    "allowNight": false,
    "allowSakura": true,
    "allowMomiji": true,
    "allowHot": true,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776214832/kra-asakusa/8/drive_pI2l-S9v_1776214832.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776214840/kra-asakusa/8/drive_Qh1FLH9p_1776214838.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776214836/kra-asakusa/8/drive_I7BxI91g_1776214834.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968599/kra-asakusa/8/drive_TBtLP44I_1775968599.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921020/kra-asakusa/8/drive_JT8bq6aQ_1775921020.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775920895/kra-asakusa/8/drive_Kf6nECtM_1775920893.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923126/kra-asakusa/8/drive_-Fir-ki9_1775923124.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922720/kra-asakusa/8/drive_JoIA8CNc_1775922720.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775921022/kra-asakusa/8/drive_oiV5ywRZ_1775921022.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923122/kra-asakusa/8/drive_rvT-NlRe_1775923122.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "One of the most versatile photo spots in Asakusa, with many different angles in one small area.\nThe signature shot has the five-story pagoda behind you, which feels very Japanese. In sakura season the cherry blossoms make it even more special. Almost every photoshoot at Sensoji stops here."
    }
  },
  {
    "id": "pin-1775920806013",
    "number": 9,
    "name": "Rokkakudo",
    "nameJa": "六角堂",
    "description": "",
    "x": 40.9,
    "y": 25.4,
    "mapsUrl": "https://maps.app.goo.gl/AvEZZ9LQVJ614p6v9",
    "tip": "Góc chụp này khi đứng từ xa có thể lấy được toàn bộ khung cảnh chùa phía sau, kết hợp với cây cầu đá tạo nên một khung hình rất đặc trưng của Nhật Bản. Khu vực này thường khá đông người qua lại, vì vậy thời điểm lý tưởng để chụp là trước 9:00 sáng để có không gian thoáng hơn. Trong trường hợp cần hậu kỳ, việc xử lý người bằng AI cũng sẽ dễ dàng hơn. Đặc biệt đẹp vào mùa lá đỏ (momiji).",
    "allowNight": false,
    "allowSakura": false,
    "allowMomiji": true,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924864/kra-asakusa/9/drive_ORkjrdO6_1775924864.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776214818/kra-asakusa/9/drive_SWrokMXC_1776214816.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968200/kra-asakusa/9/drive_edE1l4Ie_1775968198.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968268/kra-asakusa/9/drive_0tdqvv0W_1775968267.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969906/kra-asakusa/9/drive_ACXdZncy_1775969906.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968762/kra-asakusa/9/drive_gDj1r-GP_1775968761.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969474/kra-asakusa/9/drive_KCnbF7wo_1775969474.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969908/kra-asakusa/9/drive_nem9W2jM_1775969908.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924741/kra-asakusa/9/drive_txS949zq_1775924741.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924743/kra-asakusa/9/drive_ZEuyD5w8_1775924743.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968763/kra-asakusa/9/drive_ZsIQzowH_1775968763.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "From a distance this angle captures the whole temple behind you, together with the stone bridge, for a classic Japanese frame. The area is usually busy with people passing by, so the best time to shoot is before 9:00 am when it is quieter. If editing is needed, removing people with AI is also easier here. Especially beautiful in the red-leaf (momiji) season."
    }
  },
  {
    "id": "pin-1775921633783",
    "number": 10,
    "name": "Nitemmon",
    "nameJa": "二天門",
    "description": "",
    "x": 87.1,
    "y": 31.1,
    "mapsUrl": "https://maps.app.goo.gl/Km3Sj4GPKY7DBDFx7",
    "tip": "Đây là cổng thứ hai của chùa Sensoji, ít người biết đến nên khá yên tĩnh và dễ chụp hơn so với cổng chính.\nNếu chọn góc chụp từ xa, đặc biệt khi lấy khung qua các tán cây, sẽ tạo được cảm giác nhân vật nhỏ bé giữa kiến trúc lớn, mang lại bố cục rất ấn tượng.\nMột địa điểm phù hợp để chụp ảnh vừa có chiều sâu, vừa thể hiện được sự hùng vĩ của không gian.",
    "allowNight": false,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775970049/kra-asakusa/10/drive_KqDKfy0a_1775970047.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968731/kra-asakusa/10/drive_Mp3NnE7q_1775968729.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973897/kra-asakusa/10/drive__1zwBfgr_1775973896.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776091432/kra-asakusa/10/drive_Uc4yTbM8_1776091431.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968727/kra-asakusa/10/drive_UKTl6gfc_1775968726.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776091426/kra-asakusa/10/drive_W5IDu6QR_1776091424.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776088495/kra-asakusa/10/drive_WZtQshjm_1776088494.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776091429/kra-asakusa/10/drive_ZATXVY_A_1776091428.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "This is Sensoji's second gate. Few people know it, so it is quiet and much easier to shoot than the main gate.\nShoot from a distance, especially framing through the trees, and you look small against the grand architecture, for a very striking composition.\nA great spot for photos with depth that also show the scale of the place."
    }
  },
  {
    "id": "pin-1775921744065",
    "number": 11,
    "name": "Asakusa Shrine (1)",
    "nameJa": "浅草神社",
    "description": "",
    "x": 73.8,
    "y": 24.8,
    "mapsUrl": "https://maps.app.goo.gl/chADHZaobkuLcT7r5",
    "tip": "Đây là một góc chụp rất đẹp vào mùa lá vàng, với cây lớn tạo nên background nổi bật. Vào thời điểm này, khu vực trở thành một trong những spot được chụp nhiều nhất.\nNgoài mùa lá vàng, vẫn có thể chụp với view cổng đền (神社) mang nét truyền thống Nhật Bản.\nThời điểm đẹp nhất là buổi sáng khi còn vắng người, hoặc buổi chiều với ánh nắng cuối ngày. Chụp ngược sáng với hàng cây phía sau sẽ tạo hiệu ứng rất đẹp.",
    "allowNight": false,
    "allowSakura": true,
    "allowMomiji": true,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/11/drive_4mB-E46B_1775968426.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/11/drive_6Jxvf8YI_1775967229.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/11/drive_e0BHZy0V_1775967353.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/11/drive_COoYxMFu_1775924693.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/11/drive_HFUTmWCh_1775967225.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "A beautiful spot in the golden-leaf season, when the big tree makes a stunning background. At that time of year it becomes one of the most photographed spots.\nOutside the golden-leaf season you can still shoot with the shrine gate, full of traditional Japanese character.\nThe best time is early morning while it is still quiet, or late afternoon in the last sunlight. Shooting against the light with the trees behind you gives a lovely effect."
    }
  },
  {
    "id": "pin-1775921856187",
    "number": 12,
    "name": "Yogodo Hall (1)",
    "nameJa": "影向堂",
    "description": "",
    "x": 33.7,
    "y": 15.5,
    "mapsUrl": "https://maps.app.goo.gl/fFnk1ZX2MAbfokEu8",
    "tip": "Tại Yogodo Hall (影向堂), bạn có thể chụp với các mảng tường đỏ nổi bật, tạo nên khung hình đậm chất Nhật Bản.\nChỉ cần thay đổi góc chụp nhẹ, có thể lấy thêm chùa Sensoji phía sau, giúp bức ảnh có chiều sâu và điểm nhấn rõ ràng hơn.",
    "allowNight": false,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/12/drive_PAWdDzvC_1775969417.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/12/drive_X7DlTzUS_1775969420.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/12/drive_cP1jAvbb_1775923056.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/12/drive_jWe2jCu0_1775921898.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/12/drive_gZ-HItDw_1775969423.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/12/drive_8kt21TeF_1775921929.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/12/drive_ZRvvgiGN_1775923506.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "At Yogodo Hall (影向堂) you can shoot against bold red walls for a very Japanese frame.\nShift the angle slightly and you can also fit Sensoji's main hall behind you, giving the photo more depth and a clear focal point."
    }
  },
  {
    "id": "pin-1775922032637",
    "number": 13,
    "name": "Mitsumine Shrine",
    "nameJa": "三峯神社",
    "description": "",
    "x": 29.7,
    "y": 22.2,
    "mapsUrl": "https://maps.app.goo.gl/shwdcCHFaaT9XcHT7",
    "tip": "Đây là một trong những địa điểm chụp nổi bật vào mùa lá vàng, với cây lớn tạo nên background ấn tượng và các hàng cây xung quanh đồng loạt chuyển màu.\nNgoài mùa lá vàng, khu vực này vẫn có nhiều góc chụp đẹp với mái chùa Sensoji phía sau, kết hợp cùng không gian cây xanh tạo nên khung cảnh tự nhiên hài hòa.\nNên chụp vào buổi sáng sớm để có không gian thoáng và ít người hơn.",
    "allowNight": false,
    "allowSakura": false,
    "allowMomiji": true,
    "allowHot": true,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775967365/kra-asakusa/13/drive_BasKKteD_1775967363.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922626/kra-asakusa/13/drive_eBcAZyR5_1775922626.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924517/kra-asakusa/13/drive_TYSm8LfV_1775924516.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924459/kra-asakusa/13/drive_4GPidCZz_1775924459.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924458/kra-asakusa/13/drive_4oPslAcA_1775924458.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924199/kra-asakusa/13/drive_73p0VkPY_1775924198.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922624/kra-asakusa/13/drive_9ZwYMqb3_1775922624.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969738/kra-asakusa/13/drive_Lo5Ois3z_1775969736.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923968/kra-asakusa/13/drive_QFFS1Q9R_1775923967.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924196/kra-asakusa/13/drive_sbcFfmka_1775924195.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968346/kra-asakusa/13/drive_WTbZrOaq_1775968345.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "One of the standout spots in the golden-leaf season, when the big tree makes an impressive background and the trees all around change colour together.\nOutside that season there are still many nice angles with Sensoji's roof behind you, framed by greenery for a natural, balanced scene.\nShoot early in the morning for more space and fewer people."
    }
  },
  {
    "id": "pin-1775922147502",
    "number": 14,
    "name": "Asakusa Shrine (2)",
    "nameJa": "",
    "description": "",
    "x": 82.4,
    "y": 17.7,
    "mapsUrl": "https://maps.app.goo.gl/uwmYyEDvjS7wy4tf6",
    "tip": "Một góc chụp với background lồng đèn mang đậm không khí Nhật Bản. Khi trời tối và lồng đèn được thắp sáng, khung hình trở nên ấm áp và lung linh hơn.\nTuy không phải lúc nào cũng có lồng đèn, nhưng phần lớn thời gian trong năm khu vực này vẫn được trang trí.",
    "allowNight": false,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922269/kra-asakusa/14/drive_fnwJJ3rX_1775922267.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924671/kra-asakusa/14/drive_uXY1o-s3_1775924670.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922272/kra-asakusa/14/drive_cGVRoOqc_1775922271.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922192/kra-asakusa/14/drive_AG-IdUUc_1775922191.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969935/kra-asakusa/14/drive_E3io6gbY_1775969935.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924776/kra-asakusa/14/drive_oJjqLFMr_1775924776.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968310/kra-asakusa/14/drive_rmpGS8U7_1775968308.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924673/kra-asakusa/14/drive_XrvOD479_1775924673.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "A spot with a lantern backdrop full of Japanese atmosphere. After dark, when the lanterns are lit, the photo turns warm and glowing.\nThe lanterns are not up all the time, but the area is decorated for most of the year."
    }
  },
  {
    "id": "pin-1775922801396",
    "number": 15,
    "name": "Yogodo Hall Right",
    "nameJa": "影向堂",
    "description": "",
    "x": 42.8,
    "y": 17.3,
    "mapsUrl": "https://maps.app.goo.gl/xsnpe9e38UPFuUsj7",
    "tip": "Góc phải của Yogodo Hall (影向堂) có một cây cầu đá nhỏ, bên dưới là hồ cá koi, tạo nên khung cảnh rất yên bình.\nXung quanh là suối và cây xanh, kết hợp cùng một phần kiến trúc nhà cổ phía bên cạnh, mang lại background đậm chất Nhật Bản.\nKhi thay đổi góc chụp nhẹ, có thể thấy thêm chùa Sensoji phía sau, giúp khung hình trở nên đa lớp và giàu chiều sâu.",
    "allowNight": false,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969445/kra-asakusa/15/drive_h5BDhWdr_1775969445.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775970036/kra-asakusa/15/drive_RfCDAJMG_1775970035.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924440/kra-asakusa/15/drive_9i-eMiKI_1775924440.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969443/kra-asakusa/15/drive_AajgRhXt_1775969443.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924353/kra-asakusa/15/drive_H_cnvFaV_1775924353.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969448/kra-asakusa/15/drive_oNh-eTlh_1775969448.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923520/kra-asakusa/15/drive_vcmhQwdz_1775923519.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775924442/kra-asakusa/15/drive_w3dvKdk-_1775924442.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "On the right side of Yogodo Hall (影向堂) there is a small stone bridge over a koi pond, a very peaceful scene.\nA little stream, greenery and part of an old traditional house next to it make a very Japanese background.\nShift the angle slightly and Sensoji appears behind you, adding layers and depth to the frame."
    }
  },
  {
    "id": "pin-1775922848504",
    "number": 16,
    "name": "Hozomon Gate Right",
    "nameJa": "",
    "description": "",
    "x": 65.3,
    "y": 49.7,
    "mapsUrl": "https://maps.app.goo.gl/MWyqfcVhsxCvTnWw8",
    "tip": "Góc chụp này thường khá đông, nên sẽ khó chụp được khung hình sạch vào ban ngày. Thời điểm lý tưởng là trước 8:00 sáng để có ít người hơn.\nNếu chụp vào giờ cao điểm, có thể đợi dòng người thưa bớt hoặc tận dụng chuyển động để tạo hiệu ứng bóng người mờ.\nBuổi tối cũng là một lựa chọn đẹp, khi vẫn có thể lấy được tháp 5 tầng phía sau trong khung hình.",
    "allowNight": false,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776214864/kra-asakusa/16/drive_OaQbeUiT_1776214864.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775923997/kra-asakusa/16/drive_2RcIgjYy_1775923997.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922888/kra-asakusa/16/drive_9qHurH9m_1775922887.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775922884/kra-asakusa/16/drive_OnBhkM-K_1775922883.jpg"
    ],
    "hiddenPhotos": [],
    "photos": [],
    "tipTranslations": {
      "en": "This spot is usually crowded, so a clean shot is hard to get during the day. The ideal time is before 8:00 am, when there are fewer people.\nAt peak times you can wait for the crowd to thin out, or use the movement to blur the passers-by into motion trails.\nEvening is a great option too, and you can still fit the five-story pagoda into the frame behind you."
    }
  },
  {
    "id": "pin-1775958590076",
    "number": 17,
    "name": "Kimono Rental Ann",
    "nameJa": "",
    "description": "",
    "x": 68.9,
    "y": 83.7,
    "mapsUrl": "https://maps.app.goo.gl/ckfUrMonrcBVZAVbA",
    "tip": "Kimono Rental Ann là điểm bắt đầu cho trải nghiệm chụp ảnh kimono tại Asakusa, nằm ngay gần chùa Sensoji.\nTừ đây có thể dễ dàng di chuyển đến hầu hết các địa điểm chụp đẹp trong khu vực chỉ trong vài phút đi bộ.\nPhù hợp để chuẩn bị trang phục, make up và bắt đầu buổi chụp một cách thuận tiện.",
    "allowNight": false,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": true,
    "photoOrder": [],
    "hiddenPhotos": [],
    "isShop": true,
    "photos": [],
    "tipTranslations": {
      "en": "Kimono Rental Ann is the starting point of your kimono photo experience in Asakusa, right next to Sensoji Temple.\nFrom here most of the best photo spots in the area are just a few minutes' walk away.\nThe easy place to get dressed, do your hair and makeup, and start your photoshoot."
    }
  },
  {
    "id": "pin-1775968018385",
    "number": 18,
    "name": "Main Hall Back",
    "nameJa": "",
    "description": "",
    "x": 59.2,
    "y": 17.8,
    "mapsUrl": "https://maps.app.goo.gl/zY82R1JgTXKF3rpL9",
    "tip": "Một góc chụp ít người biết nằm phía sau chùa Sensoji, thường khá yên tĩnh và dễ chụp.\nVào mùa lá vàng, khu vực này có thêm cây lớn phía sau tạo điểm nhấn. Ngoài ra, có thể chụp đẹp quanh năm.\nBackground là những bức tường đỏ, tạo nên phong cách tối giản nhưng vẫn rất nổi bật và sang trọng.",
    "allowNight": false,
    "allowSakura": false,
    "allowMomiji": true,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776216332/kra-asakusa/18/drive_U8zFLE4d_1776216331.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776216328/kra-asakusa/18/drive_z0sWh_wm_1776216327.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968084/kra-asakusa/18/drive_NtsMqxTZ_1775968082.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969648/kra-asakusa/18/drive_6gbx9B7F_1775969647.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776092086/kra-asakusa/18/drive_RqTCaMaI_1776092084.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969645/kra-asakusa/18/drive_b9FehSka_1775969645.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968844/kra-asakusa/18/drive_bc_WM_XL_1775968842.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969252/kra-asakusa/18/drive_h6ftPI9K_1775969250.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969662/kra-asakusa/18/drive_i5QkBfw2_1775969662.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776218258/kra-asakusa/18/drive_IQ8tdspF_1776218256.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776092083/kra-asakusa/18/drive_OJ1_SvcP_1776092081.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969635/kra-asakusa/18/drive_PA_7Zq0J_1775969634.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969638/kra-asakusa/18/drive_parrXrTZ_1775969636.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775976580/kra-asakusa/18/drive_Q9sBw18w_1775976580.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776218260/kra-asakusa/18/drive_QnCehNh4_1776218259.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969651/kra-asakusa/18/drive_TCbqfh1n_1775969650.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968960/kra-asakusa/18/drive_VnoEOn4b_1775968958.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775976576/kra-asakusa/18/drive_wRSIwbcF_1775976574.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775969642/kra-asakusa/18/drive_wYmU-0nG_1775969641.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775976579/kra-asakusa/18/drive_xjGIjAcw_1775976577.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968956/kra-asakusa/18/drive_xliZ0xta_1775968955.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776218262/kra-asakusa/18/drive_yHCZ284I_1776218262.jpg"
    ],
    "hiddenPhotos": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/18/drive_g17XRnp0_1775968949.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/18/drive_FL77B9WF_1775976887.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/18/drive_Nhtgncjt_1775976890.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775968950/kra-asakusa/18/drive_g17XRnp0_1775968949.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775976889/kra-asakusa/18/drive_FL77B9WF_1775976887.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775976892/kra-asakusa/18/drive_Nhtgncjt_1775976890.jpg"
    ],
    "isShop": false,
    "photos": [],
    "tipTranslations": {
      "en": "A little-known spot behind Sensoji's main hall, usually quiet and easy to shoot.\nIn the golden-leaf season a big tree behind you adds a focal point, and it looks good all year round.\nThe red walls make a minimal backdrop that still feels bold and elegant."
    }
  },
  {
    "id": "pin-1776215056447",
    "number": 19,
    "name": "Yogodo Hall Back",
    "nameJa": "影向堂 ",
    "description": "",
    "x": 39.6,
    "y": 9.1,
    "mapsUrl": "https://maps.app.goo.gl/ecBBtFLMh9MSqb8v9",
    "tip": "Phía sau Yogodo Hall (影向堂) có một bức tường trắng dài và sạch, tạo nên một background rất tối giản.\nKết hợp cùng cỏ cây xung quanh, đây là địa điểm phù hợp để chụp theo phong cách Nhật Bản tinh tế và nhẹ nhàng.",
    "allowNight": false,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": false,
    "photoOrder": [],
    "hiddenPhotos": [],
    "isShop": false,
    "photos": [],
    "tipTranslations": {
      "en": "Behind Yogodo Hall (影向堂) there is a long, clean white wall that makes a very minimal background.\nWith the plants and greenery around it, this is the spot for a subtle, gentle Japanese style."
    }
  }
];
